export default __webpack_public_path__ + "static/media/IMG-20210326-WA0027.973aca67.jpg";